import React from "react";
import OrderItemService from "services/order-item";

import { connect } from "react-redux";
import { loadItem } from "reducers/order";

class OrderItem extends React.Component {
  orderItemService = new OrderItemService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.orderItemService
      .getAll()
      .then(({ data }) => this.props.loadItem(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { loadItem })(OrderItem);
